import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import FeaturedArticle from '../../../../../landing-page/components/featured-article';

export const Featured = styled.div`
  padding: 0 ${layout.measurements.spacingSmall};
`;

export const Articles = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: ${layout.measurements.spacingSmall};

  div {
    /* HACK: Overwrite centering of items inside ExpandableGrid */
    align-items: flex-start;
  }
`;

export const Article = styled(FeaturedArticle)`
  display: flex;
  flex-direction: column;
  width: 25%;
  padding: 0 ${layout.measurements.spacingSmall};

  ${media.mediumDown`
    width: 100%;
    margin-bottom: ${layout.measurements.spacingMedium};
  `};
`;
